var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_28655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5H5V5H2.5V2.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0V7.5H0V0H7.5ZM6.25 1.25H1.25V6.25H6.25V1.25ZM5 15H2.5V17.5H5V15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5V20H0V12.5H7.5ZM1.25 13.75V18.75H6.25V13.75H1.25ZM15 2.5H17.5V5H15V2.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0V7.5H20V0H12.5ZM18.75 1.25V6.25H13.75V1.25H18.75ZM10 1.25V0H11.25V2.5H10V5H8.75V1.25H10ZM10 7.5V5H11.25V7.5H10ZM7.5 10V8.75H8.75V7.5H10V10H11.25V8.75H17.5V10H12.5V11.25H8.75V10H7.5ZM7.5 10V11.25H2.5V10H1.25V11.25H0V8.75H3.75V10H7.5ZM20 11.25H18.75V8.75H20V11.25ZM18.75 11.25H17.5V13.75H20V12.5H18.75V11.25ZM13.75 11.25H16.25V12.5H15V13.75H13.75V11.25ZM16.25 15V13.75H15V15H13.75V16.25H11.25V17.5H15V15H16.25ZM16.25 15H20V16.25H17.5V17.5H16.25V15ZM11.25 13.75V15H12.5V12.5H8.75V13.75H11.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15H10V18.75H15V20H8.75V15ZM20 17.5V20H16.25V18.75H18.75V17.5H20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_28655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.f321abfc169635d5a19a20bf28ce9de5.svg";
export { ForwardRef as ReactComponent };